import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import GenericDrawer from '@/components/GenericDrawer';
import { AgaveDataGrid } from '@/components/GenericTable/DataGridStyled';

import { myUsersColumn } from './myUsers-columns';
import NewUsers from './NewUsers/NewUsers';
import useMyUsers from './useMyUsers';

const MyUsersSection = () => {
  const hook = useMyUsers();
  const theme = useTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'start',
        justifyContent: 'center',
        padding: 0,
      }}
    >
      <Grid
        container
        size={{ xxs: 12 }}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
          padding: theme.spacing(2),
          gap: theme.spacing(2),
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: theme.palette.secondary.main,
            '&& span': { color: theme.palette.primary.main },
          }}
        >
          Total: <span>{hook.totalUsers}</span>
        </Typography>
        <Button variant="contained" onClick={hook.handleOpenCloseDrawer}>
          Crear nuevo usuario
        </Button>
      </Grid>

      <Box sx={{ overflowX: 'auto', width: '100%' }}>
        <Box sx={{ minWidth: '700px' }}>
          <AgaveDataGrid
            columns={myUsersColumn()}
            rows={hook.paginatedData}
            rowCount={hook.totalUsers}
            loading={hook.loading}
            localeText={{
              noRowsLabel: 'No hay usuarios disponibles',
            }}
            disableRowSelectionOnClick={true}
            getRowId={(row) => row.id}
            hideFooterSelectedRowCount={true}
            disableColumnMenu={true}
            paginationMode="client"
            pageSizeOptions={[10, 25, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            onPaginationModelChange={hook.handlePaginationChange}
          />
        </Box>
      </Box>
      <GenericDrawer
        open={hook.openCloseDrawer}
        onClose={hook.handleOpenCloseDrawer}
        title={'Crear nuevo usuario'}
        disableEscapeKeyDown={true}
        iconTitle={<GroupAddOutlinedIcon color="primary" />}
      >
        <NewUsers onSuccess={hook.handleUserCreated} />
      </GenericDrawer>
    </Paper>
  );
};

export default MyUsersSection;
